import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class FilesPedidosClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async gerarPdfPedidos(pedidoId) {
    try {
      return await this.api.get(`pdf/gerarPdfPedido/${pedidoId}`, {
        responseType: 'blob',
      });
    } catch (error) {
      console.error(error, 'Erro ao gerar PDF do pedido');
      throw error;
    }
  }
}
